export default {
  getSignatures: (data = null) => $nuxt.$axios.get($nuxt.$api.host + '/document-signing/', data),
  getSignature: (signature_uuid) => $nuxt.$axios.get($nuxt.$api.host + '/document-signing/' + signature_uuid),
  launch: (data) => $nuxt.$axios.post($nuxt.$api.host + '/document-signing/', data),
  getClientSignatures: (client_uuid, data = null) => $nuxt.$axios.get($nuxt.$api.host + '/client/' + client_uuid + '/signatures', data),
}
